import { render, staticRenderFns } from "./AccountsPage.vue?vue&type=template&id=42489a94&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42489a94')) {
      api.createRecord('42489a94', component.options)
    } else {
      api.reload('42489a94', component.options)
    }
    module.hot.accept("./AccountsPage.vue?vue&type=template&id=42489a94&", function () {
      api.rerender('42489a94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/accounts/AccountsPage.vue"
export default component.exports